import React from "react";
import TableRow from "../../../../Components/Common/TableRow";
import { convertToLocalDateTime } from "../../../../utils/convertToLocalDateTime";
import TableRowPerAction from "../../../../Components/Common/TableRowPerAction";
import { useAlert } from "../../../../Context/AlertContext";
import useToastError from "../../../../hooks/useErrorToast";
import useSWRMutation from "swr/mutation";
import TableData from "../../../../Components/Common/TableData";
import { chapterUrls } from "../../../../Api/Auth/ApiUrls";
import { sendDeleteRequestAuth } from "../../../../Api/swrConfig";
import { toast } from "react-toastify";

const ChapterRow = ({ row, mutate, onEditClick }) => {
  const { showAlert, setIsLoading } = useAlert();
  const { showErrorToast } = useToastError();

  const { trigger: deleteTrigger } = useSWRMutation(
    chapterUrls.delete(row._id),
    sendDeleteRequestAuth,
    {
      onSuccess: () => {
        setIsLoading(false);
        toast.success("Success");
        mutate();
      },
      // If error occurred - make delete false
      onError: (error) => {
        setIsLoading(false);
        showErrorToast(error);
      },
    }
  );

  const handleDelete = () => {
    showAlert(
      `Are you sure you want to delete the chapter "${row.title}"?`,
      async () => {
        setIsLoading(true);
        await deleteTrigger(row._id);
      }
    );
  };
  return (
    <>
      <TableRow key={row._id} link={`/admin/chapters/subchapters/${row._id}`}>
        <TableData>{row.no}</TableData>
        <TableData>{row.title}</TableData>

        <TableData>{convertToLocalDateTime(row.createdAt)}</TableData>
        <TableRowPerAction
          onEdit={() => onEditClick(row)}
          onDelete={handleDelete}
        />
      </TableRow>
    </>
  );
};

export default ChapterRow;
